import { mockTopics } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">热门话题</h2>
          <p className="text-sm text-foreground-600 max-w-[500px] mx-auto">
            探索当下最受欢迎的漫画话题与类型标签，找到属于你的漫画世界
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {mockTopics.map((topic) => (
            <div
              key={topic.name}
              className="group relative flex items-center gap-3 px-5 py-3 bg-background-50 border border-background-200/70 rounded-lg cursor-pointer hover:border-primary-200 transition-all duration-300"
            >
              {topic.hot && (
                <span className="absolute -top-2 -right-2 w-5 h-5 flex items-center justify-center bg-accent-500 text-background-50 rounded-full text-[10px]">
                  <i className="ri-fire-line"></i>
                </span>
              )}
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                {topic.name}
              </span>
              <span className="text-xs text-foreground-500 whitespace-nowrap">
                {topic.count.toLocaleString()}部
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}